import React from "react";

export default function RecommendedProfileSvg() {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.66666 1.66699H2.99999C2.55797 1.66699 2.13404 1.84259 1.82148 2.15515C1.50892 2.46771 1.33333 2.89163 1.33333 3.33366V16.667C1.33333 17.109 1.50892 17.5329 1.82148 17.8455C2.13404 18.1581 2.55797 18.3337 2.99999 18.3337H13C13.442 18.3337 13.8659 18.1581 14.1785 17.8455C14.4911 17.5329 14.6667 17.109 14.6667 16.667V6.66699M9.66666 1.66699L14.6667 6.66699M9.66666 1.66699V6.66699H14.6667M11.3333 10.8337H4.66666M11.3333 14.167H4.66666M6.33333 7.50033H4.66666" stroke="#344054" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}